export function calculatePriceWithoutDiscount(
  productPrice: number,
  percentDiscount: number,
): number {
  return productPrice / (1 - percentDiscount / 100);
}

export function calculateDiscountPercent(
  originalPrice: number,
  discountPrice: number,
): number {
  if (originalPrice <= 0) return 0;

  const discount = originalPrice - discountPrice;
  const percent = (discount / originalPrice) * 100;

  return Math.round(percent);
}
